import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BullPutSpreadSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28915 29.8553H7.74365L17.4133 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M17.4133 18.0225L21.5078 12.8417H30.8324" stroke="#089981" strokeWidth="2"/>
    </svg>
)


const BullPutSpread: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BullPutSpreadSvg(props)}
    </SvgIcon>
));
export default BullPutSpread